export function stickyHeader() {
  (function () {
    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var header = document.querySelector("header");
    var headerTransparent = document.querySelector(".header-transparent");

    var className = "header-transparent";
    var scrollTrigger = 60;

    if (headerTransparent && header) {
      var syncHeaderTransparentClass = function () {
        var hEl = document.getElementsByTagName("header")[0];
        if (!hEl) {
          return;
        }
        if (
          window.scrollY >= scrollTrigger ||
          window.pageYOffset >= scrollTrigger
        ) {
          hEl.classList.remove(className);
        } else {
          hEl.classList.add(className);
        }
      };
      window.addEventListener("scroll", syncHeaderTransparentClass, {
        passive: true,
      });
      syncHeaderTransparentClass();
    }

    if (header) {
      var checkScroll = function () {
        curScroll = w.scrollY || doc.scrollTop;
        if (curScroll <= 0) {
          header.classList.remove("is-hidden");
          prevScroll = curScroll;
          return;
        }

        if (curScroll > prevScroll) {
          direction = 2;
        } else if (curScroll < prevScroll) {
          direction = 1;
        }

        if (direction !== prevDirection) {
          toggleHeader(direction, curScroll);
        }

        prevScroll = curScroll;
      };

      var toggleHeader = function (direction, curScroll) {
        if (direction === 2 && curScroll > 100) {
          header.classList.add("is-hidden");
          prevDirection = direction;
        } else if (direction === 1) {
          header.classList.remove("is-hidden");
          prevDirection = direction;
        }
      };

      window.addEventListener("scroll", checkScroll);
    }
  })();
}
